import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXSortableTableHeader',
  props: {
  title: {
    type: String,
    required: true
  },
  field: {
    type: String,
    required: true
  },
  value: {
    type: String,
    default: ''
  },
  isAsc: Boolean,
  preserveSpace: Boolean
},
  emits: ['input', 'update:is-asc'],
  setup(__props, { emit }) {

const props = __props;





const selected = computed(() => props.value === props.field);

const onClick = () => {
  emit('update:is-asc', selected.value ? !props.isAsc : true);
  emit('input', props.field);
};

const isHidden = computed(() => !selected.value && props.preserveSpace);

return { __sfc: true,props, emit, selected, onClick, isHidden }
}

})